import { IAccount } from "./account/IAccount";
import { DiscountType } from "./Basket";
import { PartStatus } from "./Part";
import { BaseEntity, DefaultResponseWithData } from "./system";

export enum SalesQuoteStatus {
  Open = 0,
  Converted = 1,
  Cancelled = 2,
}

export enum SalesQuoteSkipReason {
  PartMissing = 0,
  PartDeleted = 1,
  PartSold = 2,
  AlreadyInBasket = 3,
}

export const SALES_QUOTE_STATUS_LABELS: Record<SalesQuoteStatus, string> = {
  [SalesQuoteStatus.Open]: "Open",
  [SalesQuoteStatus.Converted]: "Converted",
  [SalesQuoteStatus.Cancelled]: "Cancelled",
};

export const SALES_QUOTE_SKIP_REASON_LABELS: Record<SalesQuoteSkipReason, string> = {
  [SalesQuoteSkipReason.PartMissing]: "part no longer exists",
  [SalesQuoteSkipReason.PartDeleted]: "part has been deleted",
  [SalesQuoteSkipReason.PartSold]: "part has been sold",
  [SalesQuoteSkipReason.AlreadyInBasket]: "already in your basket",
};

export interface ISalesQuoteItem {
  id: string;
  partId: string;
  title: string | null;
  tagNumber: string | null;
  basketPrice: number | null;
  taxRate: number | null;
  partStatus: PartStatus | null;
}

export interface ISalesQuote extends BaseEntity {
  status: SalesQuoteStatus;
  createdById: string;

  contactName: string | null;
  contactEmail: string | null;
  contactPhone: string | null;
  accountId: string | null;
  accountName: string | null;
  /** Only present on the basket's embedded quote (the detail DTO carries accountName instead). */
  account?: IAccount | null;

  shippingPolicyId: string | null;
  shippingPolicyName: string | null;
  paymentMethod: number | null;
  notes: string | null;
  line1: string | null;
  line2: string | null;
  line3: string | null;
  line4: string | null;
  town: string | null;
  county: string | null;
  postcode: string | null;

  addTaxToTotal: boolean;
  discountType: DiscountType;
  discountValue: number;
  quotedTotal: number;

  convertedInvoiceId: string | null;
  convertedOn: string | null;
  cancelledOn: string | null;
  cancelledById: string | null;

  items: ISalesQuoteItem[];
}

export interface ITableSalesQuote {
  id: string;
  created: string;
  status: SalesQuoteStatus;
  contactName: string | null;
  contactEmail: string | null;
  contactPhone: string | null;
  accountId: string | null;
  accountName: string | null;
  itemCount: number;
  quotedTotal: number;
  createdById: string;
  convertedInvoiceId: string | null;
}

/** Mirrors the checkout body so the basket builds one payload for both. */
export interface ICreateSalesQuoteRequest {
  contactName?: string;
  contactEmail?: string;
  contactPhone?: string;
  accountId?: string;
  shippingPolicyId?: string;
  paymentMethod?: number;
  line1?: string;
  line2?: string;
  line3?: string;
  line4?: string;
  town?: string;
  county?: string;
  postcode?: string;
  notes?: string;
  addTaxToTotal: boolean;
  discountType: DiscountType;
  discountValue: number;
  quotedTotal: number;
}

export interface ISkippedSalesQuoteItem {
  partId: string;
  title: string | null;
  tagNumber: string | null;
  reason: SalesQuoteSkipReason;
}

export interface ILoadSalesQuoteResponse {
  salesQuoteId: string;
  loadedCount: number;
  skipped: ISkippedSalesQuoteItem[];
}

export interface ISalesQuoteResponse extends DefaultResponseWithData<ISalesQuote> {}
export interface ILoadSalesQuoteResponseEnvelope extends DefaultResponseWithData<ILoadSalesQuoteResponse> {}
